import { render, staticRenderFns } from "./AircraftTransferPeopleBtn.vue?vue&type=template&id=e106309a&scoped=true&"
import script from "./AircraftTransferPeopleBtn.vue?vue&type=script&lang=js&"
export * from "./AircraftTransferPeopleBtn.vue?vue&type=script&lang=js&"
import style0 from "./AircraftTransferPeopleBtn.vue?vue&type=style&index=0&id=e106309a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e106309a",
  null
  
)

export default component.exports